import React from "react";
const config = require("../config");
const helper = require("../helper");
const Modal = require("../comp_misc").modal;
const helperFile = require("./admin_helper.js");
const Pager = require("../comp_misc").pager;

// https://reactjs.org/docs/lists-and-keys.html react lists


var g_link = "/admin/certificates";

function ListItem(props) {
  // Correct! There is no need to specify the key here:
  return <tr>
    <td>{props.item.providerName}</td>
<td>{props.item.name}</td>
<td><img src={'/api/media/cert'+props.item.id+'.svg'} width="50" height="50" alt=''/></td>
  <td align="center"><button type="button" class="btn btn-outline-primary" onClick={() =>
    {
    props.parent.showModal(props.item) }
  }><i class="fa fa-edit mr-2" aria-hidden="true"></i>Edit</button></td>  

</tr>

}

class ModalList1 extends React.Component {
  

  constructor(props)
  {
    super(props);
    var params = helper.parseQuery();
    var page = params.p;
    if (!page)
      page = 0;

    this.state = {
      rows: null,
      error:null,
      image: null,
      page: page,
      
    };
  }


checkInits()
{

}

fillList(filter)
{
  var rows1 = [];

  helper.getFromServer(g_link+"?dw=get&filter="+filter)
  .then(res => {

    this.setState({showForm: false, rows: res.result, options: res.options, count: res.options.count});
  })



}
 componentDidMount() {
  this.fillList()  
  }
  hideModal()
  {
    this.setState({show: false});
  }

  showModal(item) {
    this.setState({showForm: true, id: item.id, name: item.name, notes: item.notes, providerId: item.providerId, image: "/api/media/cert"+item.id+".svg",alert: '', error: ""});
}

saveItem() {
    helper.postToServer(g_link, {dw: "update", id: this.state.id, providerId: this.state.providerId, name: this.state.name, notes: this.state.notes }, true)
.then(res => {
      this.fillList();
    })
    .catch(err => {
      helper.handleError(err);
    })

  }

  addItem()
  {
    var item = {id: -1};
    this.showModal(item);
  }

  deleteItem()
  {

    helper.postToServer(g_link, {dw: "del", id: this.state.id}, true)
    .then(res => {
      this.fillList()
    })
    .catch(err => {
      alert("AU Said : "+err)
    })

  }
  
  hiCheck1(event)
  {
    const target = event.target;
    const name = target.name;
    let value;
    if (target.checked)
      value = target.checked;
    else
      value = 0;

      this.setState({
        [name]: value
      });
  }

  
  filter(event)
  {
    const target = event.target;
//    const name = target.name;
    var value = target.value;

    this.fillList(value);

  }

  hic(event) {

    const target = event.target;
    const name = target.name;

    let value;
//    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'checkbox')
    {
      value = this.state[name];
      if (!value)
        value = [];
        // assumes DOM won't feed us dupes
        var vint = parseInt(target.value);

      if (target.checked)
      {
        value.push(vint);
      }
      else
      {
        var index = value.indexOf(vint);
        if (index !== -1) value.splice(index, 1);
      }
    }
    else
    {
      value = target.value;
    }
    this.setState({
      [name]: value
    });
  
  }

  onFile() {

  // OE??!! Fix this because it it confusing and only allows 1 _t per page
    var file = document.getElementById("certUpload").files[0];
  
    var formData = new FormData();
    formData.append('file', file);
    formData.append('id', this.state.id)
    formData.append("dw", "saveFile")
    
    fetch(config.back+g_link+"_up", {
      method: 'POST', credentials: "same-origin",
      body: formData
    }).then(response => response.json())
    .then(res => {
      
      this.setState({image: "/api/media/cert"+this.state.id+".svg?"+new Date().getMilliseconds(),
    alert: "File was uploaded"});
    })
    .catch(error => { 
      alert(error);
    });
   //.then(response => console.log('Success:', response));
    
  }
    

  render() {
document.title = "Certificates";

let spinner;
let pager;
if (!this.state.rows)
{
  spinner = <div class="d-flex justify-content-center">
  <div class="spinner-border spinner text-primary" role="status">
      <span class="sr-only">Loading...</span>
  </div>
</div>;
}
else
{
  pager = <Pager page={this.state.page} count={this.state.options.count} link={g_link}/>;
}

var error1 = <div class="alert alert-danger" role="alert">
<i class="fa fa-times mr-2" aria-hidden="true"></i>{this.state.error}
</div>;
if (!this.state.error)
error1 = <div></div>;
var alert1 = <div class="alert alert-success" role="alert">
<i class="fa fa-check mr-2" aria-hidden="true"></i>{this.state.alert}
</div>;

if (!this.state.alert)
    alert1 = <div></div>

let listItems;
var filterItems = [];

if (this.state.rows)
{


  listItems = this.state.rows.map((item, index) =>

    <ListItem key={index} item={item} parent={this} />
  );

  if (this.state.options.filters)
  {
    this.state.options.filters.map((item) => {
      filterItems.push(<option value={item.id}>{item.name}</option>)
    });
  }

}
if (this.state.showForm)
{
  this.checkInits();
  var providerList = this.state.options.providerList.map((item, index) =>
                <option value={item.id}>{item.name}</option>);

  
  

  let deleteButton;

  if (this.state.id != -1)
  {
    deleteButton = <button type="submit" class="btn btn-danger mt-4" onClick={this.deleteItem.bind(this)}>Delete</button>
  }

  return(
<div>{helperFile.nav()}

    <div class="container my-4">
        <h2 class="text-primary mb-4"><i class="fa fa-certificate mr-2" aria-hidden="true"></i>Certificates Form</h2>
        
{/*<!-- Error & Feedback alerts Show/hide as needed -->*/}
    {alert1}
    {error1}
        
{/*<!-- user info block start -->*/}
        <div class="data-container">
            <div class="row mb-2">
                <div class="col-12">
                    <h4>Add/Edit Certificates</h4>
                </div>
            </div>
            <hr class="border-primary mb-4"/>
            
{/*<!-- form start -->*/}
        <div class="row">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                <p>Certificates contain a background image along with the provider logo. Each provider can be assigned at least one certificate or more. The certificate is then assigned to a particular group of the same provider.</p>
                
                    <div class="form-group">
                        <select name="providerId" value={this.state.providerId}  onChange={this.hic.bind(this)} class="form-control">
                            <option selected>Choose provider...</option>
                            {providerList}
                        </select>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control w-40" name="name" onChange={this.hic.bind(this)} value={this.state.name} placeholder="Certificate Name"/>
                        <small id="certificateNameHelp" class="form-text text-muted">Enter a short name for the certificate</small>
                    </div>
                    <div class="form-group">
                        <textarea class="form-control" id="certificateNotes" name="notes" onChange={this.hic.bind(this)} value={this.state.notes} rows="3" placeholder="Certificate notes"></textarea>
                        <small id="certificateNotesHelp" class="form-text text-muted">Add notes or reminders for this type of certificate</small>
                    </div>
                    <div class="form-group">
                        <label for="certificateUpload">Upload certificate background image</label>
                        <input type="file" class="form-control-file" id="certUpload"  name="cert" value={this.state.cert} onChange={this.onFile.bind(this)} />
                        <img src={this.state.image} width="200" height="200" alt=""/>
                    </div>
                    <p class="text-danger font-weight-bolder font-italic">Note: if a certificate requires a signature, the signature must be included in the image</p>
                    <button class="btn btn-primary mt-4" onClick={this.saveItem.bind(this)}>Add/Update Certificate</button>&nbsp;{deleteButton}&nbsp;<button class="btn btn-danger mt-4" onClick={() => {this.setState({showForm:false})}}>Close</button>
              
            </div>
        </div>
     </div>
 </div>
      

</div>


  )
  }
  else
  {
return(
<div>
  {spinner}
{helperFile.nav()}

    <div class="container my-4">
        <h2 class="text-primary mb-4"><i class="fa fa-database mr-2" aria-hidden="true"></i>Certificates</h2>

        <div class="data-container">
            <div class="row mb-2">
                <div class="col-8">
                    <p>Certificates are associated with providers, you may filter by typing the name of the provider in the Search field to show certificates belongs to a specific provider.</p>
                </div>
                <div class="col-4">
                    <div class="card bg-secondary">
                        <div class="card-body text-center font-weight-bolder text-white">
                        Certificates: {this.state.count}
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            

            <div class="container d-flex my-4 px-0 justify-content-between">
                <a class="btn btn-primary" role="button" onClick={this.addItem.bind(this)}><i class="fa fa-database mr-2" aria-hidden="true"></i>Add Certificate</a>
                <input class="form-control w-40" id="myInput" type="text" placeholder="Search.. by anything"/>
            </div>
            

            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <table class="table mb-0 table-hover">
                      <thead>
                        <tr>
                          <th scope="col" >Provider</th>
                          <th scope="col" >Certificate Name</th>
                          <th scope="col">Image File</th>
                          <th scope="col" class="text-center" width="120" >Action</th>
                        </tr>
                      </thead>
                      <tbody id="myTable">
                      {listItems}
                      </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
      

    {pager}
 {helperFile.footer()}
 
</div>

)
  }}
}


export default ModalList1
